import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { getFacilitiesExportExcel } from 'services/fund'

export default function useGetFacilities(
    setIsOpenExcelModalEmail: React.Dispatch<React.SetStateAction<boolean>>,
    setFullReportCount: React.Dispatch<React.SetStateAction<number>>
) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: string | undefined) => {
            return getFacilitiesExportExcel(payload)
        },
        onSuccess: (data) => {
            setFullReportCount(data.interval_full_report_count)
            setIsOpenExcelModalEmail(true)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { isLoading, mutate }
}
